module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-23.388c243f.png";